import { useEffect } from 'react';
import { Check } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getStoredUser } from '@shared/auth/session';

export default function IntakeSuccessScreen() {
  const navigate = useNavigate();
  const user = getStoredUser<{ firstName?: string }>();

  useEffect(() => {
    const t = setTimeout(() => navigate('/citizen/home'), 1800);
    return () => clearTimeout(t);
  }, [navigate]);

  return (
    <div
      className="flex flex-col min-h-screen p-6 items-center justify-center text-center gap-6 screen-enter"
      style={{ background: 'linear-gradient(180deg, var(--background), var(--accent))' }}
    >
      <div className="relative w-24 h-24 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full" style={{ background: 'var(--primary)', opacity: 0.15 }} />
        <div className="absolute inset-2 rounded-full" style={{ background: 'var(--primary)', opacity: 0.25 }} />
        <div
          className="relative w-16 h-16 rounded-full flex items-center justify-center"
          style={{ background: 'var(--primary)' }}
        >
          <Check className="w-9 h-9 text-white" />
        </div>
      </div>
      <div className="space-y-2 max-w-[280px]">
        <h2 className="text-2xl font-extrabold tracking-tight">You're in, {user?.firstName || 'there'}.</h2>
        <p className="text-[15px] text-[color:var(--muted-foreground)]">Opening your dashboard…</p>
      </div>
    </div>
  );
}
